export default {
  regions: null,
  cities: null,
  deliveryZones: null,
  deliveryZoneDetail: null
}
